module.exports = __webpack_public_path__ + "static/media/mastercard-logo.c2520d73.svg";